import useGetUserPreferences from 'unsubscribe-ui/hooks/useGetUserPreferences';
import { usePageTitle } from 'unsubscribe-ui/hooks/usePageTitle';
import { Redirect, Placeholder } from 'unsubscribe-ui/components/basic';
import { trackBackUpRedirect } from 'unsubscribe-ui/data/TrackingEvents';
import { lazy } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ManagePrefComp = /*#__PURE__*/lazy(() => import('unsubscribe-ui/components/managePreferences'));
const ManagePreferences = () => {
  usePageTitle('pageTitle.managePreferences');
  const {
    isLoading,
    hasErrors,
    data
  } = useGetUserPreferences();
  if (isLoading) {
    return /*#__PURE__*/_jsx(Placeholder, {});
  }
  if (hasErrors || !data) {
    trackBackUpRedirect('Load Api Error');
    return /*#__PURE__*/_jsx(Redirect, {});
  }
  if ('shouldRedirect' in data) {
    return /*#__PURE__*/_jsx(Redirect, {
      url: data.url
    });
  }
  return /*#__PURE__*/_jsx(ManagePrefComp, {
    userPreferences: data
  });
};
export default ManagePreferences;